export default __webpack_public_path__ + "static/media/Tanzende-Schweine.7489dba5.png";